import docusign from "../../../assets/docusign.svg"
import { useMemo } from "react"
import { Button, ButtonProps } from "./Button"
import cn from "../../../utils/classes"
import RowContainer from "./Layout/RowContainer"
import Typography, { typographyTypes } from "./Typography"

interface DocusignLinkProps extends ButtonProps {
  onClick: () => void
  text: string
  readOnly?: boolean
}

export const DocusignLink = ({
  onClick,
  text,
  readOnly,
  ...buttonProps
}: DocusignLinkProps) => {
  const { disabled, styleOverrides } = buttonProps
  const effectiveDisable = !!disabled || !!readOnly
  const className = useMemo(() => {
    return cn(
      `border-none p-0 m-0 bg-transparent hover:bg-transparent${effectiveDisable ? " cursor-not-allowed" : ""}`,
      styleOverrides,
    )
  }, [effectiveDisable, styleOverrides])

  const handleClick = () => {
    if (!effectiveDisable) {
      onClick()
    }
  }
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (!effectiveDisable && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <Button
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      ariaDisabled={effectiveDisable}
      type="transparent"
      styleOverrides={className}
      roundedFull={false}
      {...buttonProps}
      buttonLabel={
        <RowContainer styleOverrides="items-center space-x-0">
          <img src={docusign} alt="DocuSign Logo" />
          <Typography
            variant={typographyTypes.HREF}
            text={text}
            styleOverrides="text-[#1C64F2]"
          />
        </RowContainer>
      }
    />
  )
}
